module.exports = __webpack_public_path__ + "src/assets/fonts/e7eace3e52faed10186de77ca7d82ad9.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/e7eace3e52faed10186de77ca7d82ad9.woff
// module id = 568
// module chunks = 58